import styled from 'styled-components'
import { Button, Typography } from 'antd'
import { MinusCircleOutlined } from '@ant-design/icons'
import { StyledModal as BaseModal, SecondaryButton } from '../styles'

const { Text } = Typography

export const StyledModal = styled(BaseModal)`
    & .ant-modal-body {
        padding: 20px 24px;
        max-height: 65vh;
        overflow-y: auto;
    }
    & .ant-modal-footer {
        border-top: 1px solid #f0f0f0;
        padding: 12px 24px;
    }
`

export { SecondaryButton as CancelButton }

export const SectionHeading = styled.div`
    margin: 16px 0 12px;
    padding-bottom: 8px;
    border-bottom: 1px solid #f0f0f0;
    font-size: 11px;
    font-weight: 600;
    color: #424647;
    text-transform: uppercase;
    letter-spacing: 0.06em;
`

export const IngredientRow = styled.div`
    display: grid;
    grid-template-columns: 2fr 1fr 1.5fr 2fr 28px;
    gap: 8px;
    align-items: flex-start;
    margin-bottom: 4px;
`

export const IngredientHeader = styled.div`
    display: grid;
    grid-template-columns: 2fr 1fr 1.5fr 2fr 28px;
    gap: 8px;
    margin-bottom: 4px;
    padding: 0 0 4px;
    border-bottom: 1px solid #f0f0f0;
`

export const ColLabel = styled(Text)`
    font-size: 11px;
    color: #8c8c8c;
    font-weight: 500;
    text-transform: uppercase;
    letter-spacing: 0.05em;
`

export const RemoveButton = styled(MinusCircleOutlined)`
    font-size: 16px;
    color: #bbb;
    cursor: pointer;
    margin-top: 9px;
    transition: color 0.2s;

    &:hover {
        color: rgb(175, 35, 35);
    }
`

export const AddIngredientButton = styled(Button)`
    width: 100%;
    margin-top: 8px;
    border-radius: 6px;
    border: 1px dashed #b8d4b8;
    color: #7BAD7E;
    background: #f7fbf7;

    &:hover,
    &:focus {
        border-color: #7BAD7E;
        color: #5F8C6C;
        background: #eff7ef;
    }
`

export const SaveButton = styled(Button)`
    border-radius: 6px;
    padding: 0 20px;
    height: 36px;
    background-color: #7BAD7E;
    border: none;
    color: white;
    font-weight: 600;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
    transition: background-color 0.2s;

    &:hover,
    &:focus {
        background-color: #5F8C6C;
        border-color: transparent;
        color: white;
    }
`